import Message from 'twilio-chat/lib/message'
import {ChatMessage} from '../types/ChatMessage'
import {store} from '../index'
import { debug } from 'util';
export const UPDATE_CHAT_MESSAGES = 'UPDATE_CHAT_MESSAGES'
export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE'
export const UPDATE_NEW_MESSAGES_COUNTER = 'UPDATE_NEW_MESSAGES_COUNTER'
export const SET_TWILIO_CLIENT_INITIALIZED = 'SET_TWILIO_CLIENT_INITIALIZED'
export const MESSAGES_RECEIVED = 'MESSAGES_RECEIVED'


interface UpdateChatMessagesAction{
    type: typeof UPDATE_CHAT_MESSAGES
    payload: ChatMessage[]
}

interface AddNewMessageAction{
    type: typeof ADD_NEW_MESSAGE
    payload: ChatMessage
}

interface UpdateNewMessagesCounterAction{
    type: typeof UPDATE_NEW_MESSAGES_COUNTER,
    payload: number
}

interface SetTwilioClientInitializedAction{
    type: typeof SET_TWILIO_CLIENT_INITIALIZED
    payload: boolean
}

interface MessagesReceivedAction{
    type:typeof MESSAGES_RECEIVED
    payload: boolean
}

export type ActionType =  UpdateChatMessagesAction | UpdateNewMessagesCounterAction | SetTwilioClientInitializedAction | AddNewMessageAction | MessagesReceivedAction

export class Actions{
    
    static AddChatMessage(message: ChatMessage) {
        return (dispatch) => {
            dispatch(this.AddMessage(message))
        }
    }

    static updateNewMessagesCounter(number: number) {
       return{
        type: UPDATE_NEW_MESSAGES_COUNTER,
        payload: number
       }
    }

     static updateMessages(messages: ChatMessage[]) : UpdateChatMessagesAction {
        return {
            type: UPDATE_CHAT_MESSAGES,
            payload: messages
        }
    }

    static AddMessage(message: ChatMessage) : AddNewMessageAction {
        return {
            type: ADD_NEW_MESSAGE,
            payload: message
        }
    }

    static SetTwilioClientInitializedStatus(isClientInitialized: boolean): SetTwilioClientInitializedAction
    {
        return{
            type: SET_TWILIO_CLIENT_INITIALIZED,
            payload: isClientInitialized
        }
    }

    static MessagesReceived(status: boolean): MessagesReceivedAction
    {
        return{
            type: MESSAGES_RECEIVED,
            payload: status
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/chat.ts